DOMTokenList.prototype.addMany = function(classes) {
    var array = classes.split(' ');
    for (var i = 0, length = array.length; i < length; i++) {
        this.add(array[i]);
    }
}

DOMTokenList.prototype.removeMany = function(classes) {
    var array = classes.split(' ');
    for (var i = 0, length = array.length; i < length; i++) {
        this.remove(array[i]);
    }
}

DOMTokenList.prototype.toggleMany = function(classes) {
    var array = classes.split(' ');
    for (var i = 0, length = array.length; i < length; i++) {
        this.toggle(array[i]);
    }
}

const on = (selector, eventType, childSelector, eventHandler) => {
    const elements = document.querySelectorAll(selector)
    for (var element of elements) {
        element.addEventListener(eventType, eventOnElement => {
            if (eventOnElement.target.matches(childSelector)) {
                eventHandler(eventOnElement)
            }
        })
    }
}


window.onload = function() {
    document.addEventListener('click', function(e) {
        var outsideElements = document.querySelectorAll('[data-toggle-hide-outside]')
        for (outsideElement of outsideElements) {
            if (typeof(outsideElement) != 'undefined' && outsideElement != null) {
                var outsideElementGroup = outsideElement.getAttribute('data-toggle-group');
                var outsideElementToggleClass = outsideElement.getAttribute('data-toggle-class');

                if(outsideElement.classList.contains(outsideElementToggleClass) === true) {
                    if(!outsideElement.contains(e.target)) {
                        if(outsideElementGroup) {
                            var outsideElementTarget = outsideElement.getAttribute('data-toggle-element');
                            var outsideElementTargetDiv = document.querySelector(outsideElementTarget+'[data-toggle-group="'+outsideElementGroup+'"]');
                        } else {
                            var outsideElementTarget = outsideElement.getAttribute('data-toggle-element');
                            var outsideElementTargetDiv = document.querySelector(outsideElementTarget);
                        }

                        outsideElement.classList.removeMany(outsideElementToggleClass);
                        outsideElementTargetDiv.classList.removeMany(outsideElementToggleClass);
                    }
                }
            }
        }
    });

    on('body', 'click', '[data-toggle-element]', toggleElements);
};

function toggleElements(e) {

    // Target
    var toggleGroup = e.target.getAttribute('data-toggle-group');
    var toggleElement = e.target.getAttribute('data-toggle-element');

    // Class
    var toggleClass = e.target.getAttribute('data-toggle-class');

    if(toggleGroup) {
        var toggleElementDiv = document.querySelector(toggleElement+'[data-toggle-group="'+toggleGroup+'"]');
    } else {
        var toggleElementDiv = document.querySelector(toggleElement);
    }

    // Actions
    if(toggleElement) {
        if(toggleGroup) {
            if (toggleElementDiv.classList.contains(toggleClass)) {
                var toggleGroupDiv = document.querySelectorAll('[data-toggle-group="'+toggleGroup+'"]');

                for(var i=0; i < toggleGroupDiv.length; i++){
                    var toggleGroups = toggleGroupDiv[i];
                    toggleGroups.classList.removeMany(toggleClass);
                }
                if(g_dev === true) {
                    console.log('Toggle groups exists "' + toggleGroup + '" and element "' + toggleElement + '" doesn\'t contain toggle class "' + toggleClass + '".');
                }
                e.target.classList.removeMany('active');
            } else {
                var toggleGroupDiv = document.querySelectorAll('[data-toggle-group="'+toggleGroup+'"]');

                for(var i=0; i < toggleGroupDiv.length; i++){
                    var toggleGroups = toggleGroupDiv[i];
                    toggleGroups.classList.removeMany(toggleClass);
                }
                if(g_dev === true) {
                    console.log('Toggle groups exists "' + toggleGroup + '" and element "' + toggleElement + '" does contain toggle class "' + toggleClass + '".');
                }
                e.target.classList.addMany('active');
                toggleElementDiv.classList.addMany(toggleClass);
            }
        } else {
            if(g_dev === true) {
                console.log('No toggle group and element "'+toggleElement+'" with toggle class "'+toggleClass+'".');
            }
            e.target.classList.toggleMany('active');
            toggleElementDiv.classList.toggleMany(toggleClass);
        }
    }
}
